// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"_277wv _3WixR","vertical":"KiM_q","content":"_1xdp6","horizontal":"_3nI5S","leftText":"tv51S","centerText":"q8ure","rightText":"_2e_Nz"};